'use client';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import useTenant from 'hooks/useTenant';

const TermsConditions = () => {
  const tCheckout = useTranslations('checkout');

  const tenant = useTenant();

  return (
    <div className="sm:col-span-6">
      <p>
        <span className="text-darkGray text-sm">{tCheckout('termsPrefixText')}&nbsp;</span>
        <Link
          href={tenant?.termsUrl || '/'}
          target="_blank"
          className="underline underline-offset-4 decoration-darkGray justify-center border border-transparent text-darkGray font-bold"
        >
          <span className="text-sm">{tCheckout('termsConditions')}</span>
        </Link>
        <span className="text-darkGray text-sm">&nbsp;{tCheckout('termsSuffixText')}&nbsp;</span>
        <Link
          href={tenant?.privacyUrl || '/'}
          target="_blank"
          className="underline underline-offset-4 decoration-darkGray justify-center border border-transparent text-darkGray font-bold"
        >
          <span className="text-sm">{tCheckout('termsPrivacyPolicy')}</span>
        </Link>
      </p>
    </div>
  );
};

export default TermsConditions;
